import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../auth/useLocalStorage";

interface IUser {
  token?: string;
  user?: {
    perfil?: string;
    nombre?: string;
  };
}

const baseUser: IUser = {};

export default function AutoRedirect() {
  const [user] = useLocalStorage("user", baseUser);
  const navigate = useNavigate();

  useEffect(() => {
    // Si hay un usuario logueado, redirigir según su perfil
    if (user?.token && user?.user?.perfil) {
      const userProfile = user.user.perfil;
      
      switch (userProfile) {
        case 'Cocina':
          navigate('/', { replace: true });
          break;
        case 'PisoVenta':
          navigate('/sales-floor', { replace: true });
          break;
        default:
          // Para otros perfiles (como Administrador), ir a cocina por defecto
          navigate('/', { replace: true });
          break;
      }
    }
  }, [user, navigate]);

  // Mostrar un loading mientras se determina la redirección
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        textAlign: 'center',
        color: '#6c757d'
      }}>
        <div style={{
          fontSize: '18px',
          marginBottom: '10px'
        }}>
          Cargando...
        </div>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e9ecef',
          borderTop: '4px solid #007bff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }}></div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
